<template>
	<div>
		<lcsj-filter more-text="更多筛选" @search="GetStoreOrderNumMonthStatistics()">
			<el-form-item label="所属门店：">
				<el-select filterable v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable size="small" @change="GetStoreOrderNumMonthStatistics">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="float: right">
				<el-radio-group v-model="echartType" border @input="changeChartType">
					<el-radio-button label="category">柱状图</el-radio-button>
					<el-radio-button label="line">折线图</el-radio-button>
				</el-radio-group>
			</el-form-item>
			</lcsj-filter>
		<div class="statisticChart"></div>
	</div>
</template>

<script>
import lcsjChartColor from "@/utils/chartColor";
import { GetStoreOrderNumMonthStatistics } from "@/api/storeOrderApi.js";
import { GetOrganizationListByConfig } from "@/api/organizationalApi.js";
import * as echarts from "echarts";
export default {
	data() {
		return {
			loading: false,
			statisticData: {
				dayList: [],
				numList: []
			},
			formInline: {
				belongStoreKeyId: ""
			},
			storeList: [],
			echartType: "category"
		};
	},
	components: {},

	created() {
		this.GetOrganizationListByConfig();
	},

	mounted() {
		// First initialize the chart with proper sequence
		this.initChart();
		// Then load data will happen automatically after getting store list
	},

	methods: {
		//切换图表类型
		changeChartType() {
			// Check if chart instance exists before operating
			if (!this.chart || this.chart.isDisposed()) {
				// If not, get container and create new instance
				const chartDom = document.querySelector(".statisticChart");
				if (chartDom) {
					this.chart = echarts.init(chartDom);
				} else {
					console.error("Chart container not found");
					return;
				}
			}

			// 根据图表类型设置配置
			const isBarChart = this.echartType === "category";
			const chartTitle = isBarChart ? "订单数量统计柱状图" : "订单数量统计折线图";
			const chartType = isBarChart ? "bar" : "line";
			const axisPointerType = isBarChart ? "shadow" : "line";

			// 设置图表选项
			const option = {
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: axisPointerType
					}
				},
				title: {
					text: chartTitle,
					subtext: "近30天",
					left: "center",
					textStyle: {
						color: "#333",
						fontSize: 18
					}
				},
				grid: {
					left: "2%",
					right: "4%",
					bottom: "2%",
					containLabel: true
				},
				xAxis: {
					name: "日期",
					type: "category",
					data: this.statisticData.dayList,
					axisLabel: {
						interval: 0,
						rotate: 30
					}
				},
				yAxis: {
					type: "value",
					name: "订单数量"
				},
				series: [
					{
						name: "订单数量",
						type: chartType,
						data: this.statisticData.numList,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0,
									color: lcsjChartColor.primary
								},
								{
									offset: 1,
									color: "#73c0de"
								}
							])
						},
						emphasis: {
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{
										offset: 0,
										color: "#2a6fc9"
									},
									{
										offset: 1,
										color: lcsjChartColor.primary
									}
								])
							}
						},
						label: {
							show: true,
							position: isBarChart ? "top" : "top"
						},
						// 折线图特有配置
						smooth: !isBarChart,
						symbol: !isBarChart ? "circle" : "emptyCircle",
						symbolSize: !isBarChart ? 8 : 4
					}
				]
			};

			try {
				// 设置图表选项 with null check
				if (this.chart && !this.chart.isDisposed()) {
					this.chart.setOption(option);
				}
			} catch (error) {
				console.error("Error setting chart option:", error);
			}
		},
		//初始化柱状图
		initChart() {
			// Get chart container
			const chartDom = document.querySelector(".statisticChart");
			if (chartDom) {
				// Initialize echarts instance
				this.chart = echarts.init(chartDom);
				// 设置图表选项 with empty data to initialize properly
				this.chart.setOption({
					tooltip: {
						trigger: "axis"
					},
					title: {
						text: "订单数量统计柱状图",
						subtext: "近30天",
						left: "center",
						textStyle: {
							color: "#333",
							fontSize: 18
						}
					},
					grid: {
						left: "2%",
						right: "4%",
						bottom: "2%",
						containLabel: true
					},
					xAxis: {
						name: "日期",
						type: "category",
						data: []
					},
					yAxis: {
						type: "value",
						name: "订单数量"
					},
					series: []
				});
				// 监听窗口大小变化，调整图表大小 with null check
				window.addEventListener("resize", () => {
					if (this.chart && !this.chart.isDisposed()) {
						this.chart.resize();
					}
				});
			}
		},
		//获取统计数据
		GetStoreOrderNumMonthStatistics() {
			let param = {
				keyId: this.formInline.belongStoreKeyId
			};
			GetStoreOrderNumMonthStatistics(param).then((res) => {
				if (res.code == 1) {
					if (res.data) {
						this.statisticData.dayList = [];
						this.statisticData.numList = [];
						let list = res.data.dtls;
						list.forEach((item) => {
							this.statisticData.dayList.push(item.dateStr);
							this.statisticData.numList.push(item.count);
						});
						// 数据更新后刷新图表 with proper check
						if (this.chart && !this.chart.isDisposed()) {
							// 调用changeChartType方法重新渲染整个图表，确保图表类型、标题等配置也能正确更新
							this.changeChartType();
						} else if (!this.chart) {
							// If chart instance doesn't exist, create one first
							this.initChart();
							this.changeChartType();
						}
					}
				} else {
					this.$message({
						type: "info",
						message: res.msg
					});
				}
			});
		},
		// 获取所属门店
		GetOrganizationListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrganizationListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = res.data;
						this.storeList.unshift({
							keyId: "",
							value: "全部"
						});
						this.GetStoreOrderNumMonthStatistics();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		}
	},

	// Clean up chart resources when component is destroyed
	beforeUnmount() {
		if (this.chart && !this.chart.isDisposed()) {
			this.chart.dispose();
		}
		// Remove event listeners
		window.removeEventListener("resize", this.handleResize);
	},

	// Helper method for resize handling
	handleResize() {
		if (this.chart && !this.chart.isDisposed()) {
			this.chart.resize();
		}
	}
};
</script>

<style scoped lang="scss">
.work_title_color {
	width: 5px;
	height: 20px;
	background-color: var(--app-primary);
	display: inline-block;
	padding: 0;
	margin: 0;
}

.work_title {
	font-size: 16px;
	font-weight: 700;
	font-family: 微软雅黑;
	padding: 0;
	margin: 0;
	margin-left: 10px;
	display: inline-block;
}

.statisticChart {
	width: 100%;
	height: 600px;
	margin-top: 10px;
	padding-top: 20px;
	background-color: var(--app-surface);
	border-radius: 10px;
}
</style>
